/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .form-details {
    .card-header {
      background-color: ${$.primaryMain};
      color: ${$.white};
    }
  }

  @media (min-width: 1400px) {
    .form-details {
      position: fixed;
      top: 8.7rem;
      right: 0.5rem;
      max-width: 320px;
      width: 100%;
      border-radius: 0.5rem;
      overflow-y: auto;
      overflow-x: hidden;
      max-height: calc(100vh - 200px);
      padding: 0.5rem;

      .card-header,
      .card-body {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1199.98px) {
    .form-details {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(2, auto);
      grid-auto-flow: column;
      grid-column-gap: 0px;
      grid-row-gap: 0px;
      margin-bottom: 1rem;
    }
  }

  @media (max-width: 575.98px) {
    .form-details {
      .card-header:not(:first-of-type) {
        background-color: ${$.secondaryMain};
      }
    }
  }
`;
